module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/pilates-6c5fc66f08885d9f3648918435e5b540.png";